import styled from '@emotion/styled';
import { css } from '@emotion/core';
import media from 'css-in-js-media';

export const HeroFormContainer = styled.div`
  .formWrapperParent {
    max-width: 495px;
    width: 100%;
    display: inline-block;
  }

  .inputFormWrapper {
    position: relative;
    max-width: 495px;
    display: inline-block;
    width: 100%;

    .absolutePlaceholder {
      position: absolute;
      left: 25px;
      top: 10px;
      font-size: 12px;
      display: none;

      &.isActive {
        display: block;
        transition: all 0.3s ease;
      }

      &.isHidden {
        display: none;
        transition: all 0.3s ease;
      }
    }

    .inputNameError {
      display: inline-block;
      color: #cc0000;
      font-size: 12px;
      position: absolute;
      top: 10px;
      left: 90px;
      display: none;

      &.isActive {
        display: block;
      }

      &.isHidden {
        display: none;
      }
    }

    .inputPasswordError {
      display: inline-block;
      color: #cc0000;
      font-size: 12px;
      position: absolute;
      top: 10px;
      left: 84px;
      display: none;

      &.isActive {
        display: block;
      }

      &.isHidden {
        display: none;
      }
    }

    .inputEmailError {
      display: inline-block;
      color: #cc0000;
      font-size: 12px;
      position: absolute;
      top: 10px;
      left: 59px;
      display: none;

      &.isActive {
        display: block;
      }

      &.isHidden {
        display: none;
      }
    }
  }

  input {
    max-width: 416px;
    width: 100%;
    height: 56px;
    border: none;
    margin: 8px 0;
    color: #0c182f;
    padding-left: 24px;
    background: #ffffff;
    box-shadow: 0px 8px 16px rgba(0, 8, 36, 0.05);
    border-radius: 8px;

    &:hover {
      box-shadow: 0px 10px 16px rgba(0, 8, 36, 0.1);
      cursor: default;
      transition: all 0.3s ease;
    }
  }

  input::placeholder {
    color: #0c182f;
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
  }

  input:focus {
    outline: none;
  }

  .iconWrapper {
    display: inline-block;
    width: 56px;
    height: 56px;
    left: 0px;
    top: 0px;
    background: #ffffff;
    box-shadow: 0px 8px 16px rgba(0, 8, 36, 0.05);
    border-radius: 100px;

    &:first-child {
      margin: 0 16px 0 24px;

      @media (max-width: 1004px) {
        margin: 0 16px 0 16px;
      }
    }

    &:hover {
      background-color: #f2f8ff;
    }
  }
  .buttonWrapper {
    display: inline-block;
    justify-content: center;
    margin-top: 30px;
    max-width: 495px;
    width: 100%;
    text-align: left;

    @media (max-width: 1004px) {
      text-align: center;
    }

    ${media('<tablet')} {
      text-align: center;
    }

    @media (max-width: 1004px) {
      display: center;
    }

    .signupBtnWrapper {
      display: inline-block;
      margin-bottom: 20px;
      vertical-align: top;

      @media (max-width: 1004px) {
        width: 100%;
      }

      ${media('<tablet')} {
        width: 100%;
      }

      .is-full-width {
        min-width: 210px;

        @media (max-width: 1004px) {
          width: 100%;
        }

        ${media('<tablet')} {
          width: 100%;
        }
      }
    }

    .iconWrapperMaster {
      display: inline-block;

      ${media('<tablet')} {
        display: flex;
        justify-content: center;
      }
    }
  }

  .iconPositionWrapper {
    position: absolute;
    bottom: 40px;

    @media (max-width: 1004px) {
      position: relative;
      bottom: 0;
      margin-bottom: 25px;
      display: inline-block;
    }
  }

  .termsLink {
    font-family: 'WorkSans-Regular', 'Helvetica', 'sans-serif';
    font-size: 12px;
    line-height: 16px;
    text-align: left;
    color: rgba(23, 28, 54, 0.5);

    a {
      text-decoration: underline;
    }

    @media (max-width: 1004px) {
      text-align: center;
    }
  }
`;

export const styledButtonModernForm = css`
  border: none;
  padding: 16px;

  &:hover {
    background-color: #f8fbff;
  }
`;
